import { ReactNode } from "react";
import { Link } from "wouter";
import { Icon, IconName } from "../icon";
import * as css from "./style.css";

function Pressable(props: {
  onClick?: () => void;
  href?: string;
  children?: ReactNode;
  className?: string;
}) {
  const { href, ...rest } = props;

  if (href) {
    return (
      <Link href={href} {...rest}>
        {props.children}
      </Link>
    );
  }

  return (
    <button type="button" {...rest}>
      {props.children}
    </button>
  );
}

export function IconButton(props: {
  icon: IconName;
  onClick?: () => void;
  href?: string;
  label: string;
}) {
  const { icon, label, ...rest } = props;

  return (
    <Pressable {...rest} className={css.button}>
      <div className={css.iconHover} />
      <Icon name={icon} title={label} />
    </Pressable>
  );
}
